import { useInvoicingCapabilityQuery } from './InvoicingCapability.generated';

/**
 * Finance sees everything; only the invoicing owner (or an administrator)
 * acts. Action buttons stay rendered and visible for finance users, but
 * disabled at 45% opacity with a tooltip naming who can act — the process
 * should be discoverable, not hidden. The backend enforces the same rule.
 */
export type InvoicingCapability = {
  canAct: boolean;
  ownerName: string | null;
  loading: boolean;
};

export function useInvoicingCapability(): InvoicingCapability {
  const { data, loading } = useInvoicingCapabilityQuery();
  return {
    canAct: data?.invoicingCapability.can_act ?? false,
    ownerName: data?.invoicingCapability.owner_name ?? null,
    loading,
  };
}

export function capabilityTooltip(capability: InvoicingCapability): string {
  return capability.ownerName
    ? `Only the invoicing owner (${capability.ownerName}) can start or charge runs.`
    : 'Only the invoicing owner can start or charge runs.';
}
